<style src="./ItemQuote.scss" lang="scss"></style>
<template>
  <main class="item-quote">
    <content-header path="Resultado" />

    <!-- <is-closed-task
      :stageId="stage._id"
      :eventId="eventId"
      v-model="isStageOpened" /> -->
    <section v-if="isStageOpened" class="container">
      <ul class="suppliers">
        <li class="title">
          <span class="title"> Fornecedores </span>

          <div
            @click="toggleResponseSuppliers"
            class="filter"
            title="Exibirá também os fornecedores que não respondem cotação"
          >
            {{
              activeFilter.showNoResponseSuppliers
                ? "Ocultar quem não repsonde"
                : "Mostrar Todas"
            }}
          </div>
        </li>
        <li
          v-for="(supplier, supplierId) in filteredSuppliers"
          :key="supplierId"
          @click="openContextMenu({ supplierId })"
          :class="{ 'active-filter': activeFilter.showQuoted === supplierId }"
          class="supplier"
        >
          <div class="info">
            <icon-check class="icon check" v-if="!!supplier.receiveDate" />
            <icon-danger
              class="icon alert"
              v-if="!supplier.receiveDate && supplier.requestDate"
            />
            <span
              class="name"
              :class="{ norespondquotation: supplier.noRespondQuotation }"
            >
              {{ supplier.name }}
            </span>

            <span
              :class="{
                incomplete:
                  Number(supplier.itemsReceived) < supplier.itemsQuoted.length,
                complete:
                  Number(supplier.itemsReceived) > 0 &&
                  Number(supplier.itemsReceived) ===
                    supplier.itemsQuoted.length,
              }"
              class="quantity"
              title="Quantidade de itens cotados com essa marca"
            >
              {{ supplier.itemsQuoted.length }}
            </span>
            <span
              class="quantity quantityTotal"
              title="Quantidade total dos itens com essa marca"
              >{{ supplier.total }}</span
            >
          </div>

          <ul
            v-click-outside="closeContextMenu"
            v-if="contextMenu === supplierId"
            class="options-menu"
          >
            <li class="information">
              Total cotado

              <span class="sentquote"
                ><small>R$</small>
                {{ (supplier.price || 0) | CurrencyBR }}</span
              >
            </li>
            <li @click="showMentioned({ supplierId })" class="options-item">
              Visualizar Mencionados
              <icon-check
                class="icon icon-success"
                v-if="activeFilter.showMentioned === supplierId"
              />
            </li>
            <li @click="showQuoted({ supplierId })" class="options-item">
              Visualizar Selecionados
              <icon-check
                class="icon icon-success"
                v-if="activeFilter.showQuoted === supplierId"
              />
            </li>
            <li @click="selectAll({ supplierId })" class="options-item">
              Selecionar Todos o{{ supplier.total > 1 ? "s" : "" }}
              {{ supplier.total }} itens
            </li>
            <li
              :class="{ deactivated: supplier.itemsQuoted.length === 0 }"
              @click="
                supplier.itemsQuoted.length > 0 &&
                  exportPlainList({ supplierId })
              "
              class="options-item"
            >
              Exportar lista plana
            </li>
            <li
              :class="{ deactivated: supplier.itemsQuoted.length === 0 }"
              @click="
                supplier.itemsQuoted.length > 0 &&
                  exportSheetList({ supplierId })
              "
              class="options-item"
            >
              Exportar para planilha
            </li>
            <li
              :class="{ deactivated: supplier.itemsQuoted.length === 0 }"
              @click="
                supplier.itemsQuoted.length > 0 && openMail({ supplierId })
              "
              class="options-item"
            >
              Enviar e-mail
            </li>
            <li
              :class="{ deactivated: supplier.itemsQuoted.length === 0 }"
              @click="
                supplier.itemsQuoted.length > 0 &&
                  sendQuotation({
                    supplierId,
                    requestDate: supplier.requestDate,
                  })
              "
              class="options-item"
            >
              Registrar cotação

              <span v-if="supplier.requestDate" class="sentquote">{{
                supplier.requestDate | FriendlyDate
              }}</span>
            </li>
            <li
              :class="{ deactivated: supplier.itemsQuoted.length === 0 }"
              @click="
                supplier.itemsQuoted.length > 0 &&
                  responseQuotation({ supplierId })
              "
              class="options-item"
            >
              Informar Cotação

              <span v-if="supplier.requestDate" class="sentquote"
                >{{ supplier.itemsReceived }} /
                {{ supplier.itemsQuoted.length }}</span
              >
            </li>
          </ul>
        </li>
      </ul>

      <template v-if="isStageOpened">
        <ul class="quote-list-items">
          <template v-if="!responseMode">
            <section class="filters">
              <div class="filter">
                <span class="label">Associado Unit</span>
                <div class="fields">
                  <select
                    v-model="itemsFilters.costUnitSignal"
                    @change="filterItemsResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    @debounce="filterItemsByUnitCost"
                  />
                </div>
              </div>
              <div class="filter">
                <span class="label">Associado Total</span>
                <div class="fields">
                  <select
                    v-model="itemsFilters.costTotalSignal"
                    @change="filterItemsResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    @debounce="filterItemsByTotalCost"
                  />
                </div>
              </div>
              <div class="filter">
                <span class="label">Margem</span>
                <div class="fields">
                  <select
                    v-model="itemsFilters.marginProfitSignal"
                    @change="filterItemsResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    precision="0"
                    @debounce="filterItemsByMargin"
                  />
                </div>
              </div>
              <div class="filter">
                <span class="label">Estimado Unit</span>
                <div class="fields">
                  <select
                    v-model="itemsFilters.estimateUnitSignal"
                    @change="filterItemsResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    @debounce="filterItemsByUnitEstimated"
                  />
                </div>
              </div>
              <div class="filter">
                <span class="label">Estimado Total</span>
                <div class="fields">
                  <select
                    v-model="itemsFilters.estimateTotalSignal"
                    @change="filterItemsResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    @debounce="filterItemsByTotalEstimated"
                  />
                </div>
              </div>
            </section>

            <div class="loading" v-show="isLoading">
              <span class="title">Atualizando a lista</span>
              <icon-wait class="icon" />
            </div>
            <template v-if="!isLoading">
              <list-items
                v-for="(item, itemIdx) in filteredComputedItems"
                :key="itemIdx"
                :item="item"
                :itemIdx="itemIdx"
              />
            </template>
          </template>

          <template v-if="responseMode">
            <div class="filters">
              <div class="filter">
                <span class="label">Cotados</span>
                <div class="fields">
                  <select
                    v-model="responseFilters.quoted"
                    @change="filterResponseResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="all">Todos</option>
                    <option value="quoted">Só Cotados</option>
                    <option value="notquoted">Não Cotados</option>
                  </select>
                </div>
              </div>

              <div class="filter">
                <span class="label">Custo Unit</span>
                <div class="fields">
                  <select
                    v-model="responseFilters.costUnitSignal"
                    @change="filterResponseResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    @debounce="filterByUnitCost"
                  />
                </div>
              </div>

              <div class="filter">
                <span class="label">Custo Total</span>
                <div class="fields">
                  <select
                    v-model="responseFilters.costTotalSignal"
                    @change="filterResponseResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    @debounce="filterByTotalCost"
                  />
                </div>
              </div>

              <div class="filter">
                <span class="label">Margem</span>
                <div class="fields">
                  <select
                    v-model="responseFilters.marginProfitSignal"
                    @change="filterResponseResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    precision="0"
                    @debounce="filterByMargin"
                  />
                </div>
              </div>

              <div class="filter">
                <span class="label">Estimado Unit.</span>
                <div class="fields">
                  <select
                    v-model="responseFilters.estimateUnitSignal"
                    @change="filterResponseResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    precision="0"
                    @debounce="filterByUnitEstimate"
                  />
                </div>
              </div>

              <div class="filter">
                <span class="label">Estimado Total</span>
                <div class="fields">
                  <select
                    v-model="responseFilters.estimateTotalSignal"
                    @change="filterResponseResult"
                    class="cp1-small-select selectfield"
                  >
                    <option value="gte">Maior</option>
                    <option value="lte">Menor</option>
                  </select>
                  <moneybox-small
                    type="text"
                    class="inputfield"
                    precision="0"
                    @debounce="filterByTotalEstimate"
                  />
                </div>
              </div>
            </div>
            <response-items
              v-for="(item, itemIdx) in filteredComputedItems"
              :key="itemIdx"
              :item="item"
              :itemIdx="itemIdx"
              :supplierId="activeFilter.showQuoted"
              @saved-item="refreshResponseList"
            />
          </template>
        </ul>
      </template>
    </section>

    <request-confirm
      name="modalRequestConfirm"
      @close="closeModalRequestConfirm"
      :modalRequestForm="modalRequestForm"
    />
  </main>
</template>

<script>
import ContentHeader from "@/components/foundation/content-header/ContentHeader";
import {
  IconCheck,
  IconDanger,
  IconFilter,
  IconWait,
} from "@/components/primitives/icons";
import {
  CurrencyBR,
  FriendlyDate,
} from "@/components/primitives/helpers/filters";
import { Datebox, Timebox, MoneyboxSmall } from "@/components/primitives";

import RequestConfirm from "./components/request-confirm/RequestConfirm";
import ListItems from "./components/list-items/ListItems";
import ResponseItems from "./components/response-items/ResponseItems";
import IsClosedTask from "@/components/foundation/is-closed-task/IsClosedTask";
import { mapGetters } from "vuex";
import moment from "moment";

const MODALITY = {
  EST: "Estimativa",
  PP: "Pregão Presencial",
  PE: "Pregão Eletrônico",
  CC: "Carta Convite",
  DE: "Dispensa Eletrônica",
};

export default {
  name: "ItemQuote",
  components: {
    ContentHeader,
    ListItems,
    RequestConfirm,
    ResponseItems,
    IsClosedTask,
    IconCheck,
    IconDanger,
    IconFilter,
    IconWait,
    Datebox,
    Timebox,
    MoneyboxSmall,
  },
  data() {
    return {
      isLoading: false,
      isStageOpened: true,
      computedItems: [],
      filteredComputedItems: [],
      contextMenu: false,
      activeFilter: {
        showQuoted: null,
        showMentioned: null,
        showNoResponseSuppliers: false,
      },
      itemsFilters: {
        costUnit: 0,
        costUnitSignal: "gte",
        costTotal: 0,
        costTotalSignal: "gte",
        quoted: "all",
        marginProfit: 0,
        marginProfitSignal: "gte",
        estimateUnit: 0,
        estimateUnitSignal: "gte",
        estimateTotal: 0,
        estimateTotalSignal: "gte",
      },
      responseFilters: {
        costUnit: 0,
        costUnitSignal: "gte",
        costTotal: 0,
        costTotalSignal: "gte",
        quoted: "all",
        marginProfit: 0,
        marginProfitSignal: "gte",
        estimateUnit: 0,
        estimateUnitSignal: "gte",
        estimateTotal: 0,
        estimateTotalSignal: "gte",
      },
      responseMode: false,
      modalRequestForm: null,
    };
  },
  filters: {
    FriendlyDate,
    CurrencyBR,
  },
  computed: {
    stage() {
      return this.$store.getters["Board/STAGE_BY_NAME"]("Resultado");
    },
    eventId() {
      return this.$route.params.id;
    },
    filteredSuppliers() {
      if (this.activeFilter.showNoResponseSuppliers) {
        return { ...this.suppliers };
      }

      const filteredSupliers = {};
      for (const supplier in this.suppliers) {
        if (
          !this.suppliers[supplier].noRespondQuotation ||
          this.suppliers[supplier].haveQuotation
        ) {
          filteredSupliers[supplier] = { ...this.suppliers[supplier] };
        }
      }

      return filteredSupliers;
    },
    ...mapGetters({
      items: "Quote/ALL_ITEMS",
      suppliers: "Quote/ALL_SUPPLIERS",
    }),
  },
  watch: {
    async responseMode(v) {
      if (!v) {
        this.isLoading = true;
        const eventId = this.$route.params.id;
        await this.$store.dispatch("Quote/LOAD_EVENT_LIST", { eventId });
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.listAllItems();
  },
  methods: {
    async listAllItems() {
      this.isLoading = true;
      const eventId = this.$route.params.id;
      if (!eventId) return false;
      await this.$store.dispatch("Quote/LOAD_EVENT_LIST", { eventId });
      this.computedItems = this.items;
      this.filteredComputedItems = this.items;
      this.isLoading = false;
    },
    closeContextMenu() {
      this.contextMenu = false;
    },
    openContextMenu({ supplierId }) {
      this.contextMenu = supplierId;
    },
    showQuoted({ supplierId }) {
      this.responseMode = false;

      if (this.activeFilter.showQuoted === supplierId) {
        this.activeFilter.showQuoted = null;
        this.activeFilter.showMentioned = null;
        this.computedItems = this.items;
        this.filteredComputedItems = this.items;
      } else {
        this.activeFilter.showMentioned = null;
        this.activeFilter.showQuoted = supplierId;
        const supplierSelection =
          this.$store.getters["Quote/SUPPLIER_BY_ID"](supplierId);
        const computedItems = this.items.filter((i) =>
          supplierSelection.itemsQuoted.includes(i._id)
        );
        this.computedItems = computedItems;
        this.filteredComputedItems = computedItems;
      }
    },
    showMentioned({ supplierId }) {
      this.responseMode = false;

      if (this.activeFilter.showMentioned === supplierId) {
        this.activeFilter.showQuoted = null;
        this.activeFilter.showMentioned = null;
        this.computedItems = this.items;
        this.filteredComputedItems = this.items;
      } else {
        this.activeFilter.showQuoted = null;
        this.activeFilter.showMentioned = supplierId;
        const computedItems = this.items.filter((i) => {
          const h = !!(
            i.suppliers &&
            i.suppliers.find((s) => s.supplier._id.toString() === supplierId)
          );
          return h;
        });

        this.computedItems = computedItems;
        this.filteredComputedItems = computedItems;
      }
    },
    selectAll({ supplierId }) {
      this.responseMode = false;

      const supplierSelection =
        this.$store.getters["Quote/SUPPLIER_BY_ID"](supplierId);

      for (const item in this.items) {
        const itemSuppliers = this.items[item].suppliers;
        if (!itemSuppliers) {
          continue;
        }

        if (!itemSuppliers.find((s) => s.supplier._id === supplierId)) {
          continue;
        }

        if (
          supplierSelection.itemsQuoted &&
          supplierSelection.itemsQuoted.includes(this.items[item]._id)
        ) {
          continue;
        }

        this.$store.commit("Quote/ADD_QUOTATION", {
          itemId: this.items[item]._id,
          supplierId,
        });
      }
    },
    exportPlainList({ supplierId }) {
      const supplier = this.$store.getters["Quote/SUPPLIER_BY_ID"](supplierId);

      if (!(supplier && supplier.itemsQuoted)) {
        return;
      }

      const items = [];
      for (const itemsQuoted of supplier.itemsQuoted) {
        const { itemInfo } =
          this.$store.getters["Quote/ITEM_BY_ID"](itemsQuoted);
        items.push(
          `* ${itemInfo.number} - ${itemInfo.description} - ${itemInfo.quantity} ${itemInfo.unity}`
        );
      }

      const body = this.mountMessageBody({
        newLine: "\n",
        items,
      });

      try {
        document.addEventListener("copy", function (e) {
          e.clipboardData.setData("text/plain", body);
          e.preventDefault();
        });
        document.execCommand("copy");
        this.$toasted.success("Resultado copiado");
      } catch (error) {
        return Error(error);
      }
    },
    exportSheetList({ supplierId }) {
      const supplier = this.$store.getters["Quote/SUPPLIER_BY_ID"](supplierId);
      if (!(supplier && supplier.itemsQuoted)) {
        return;
      }

      const rowDescription = [];
      rowDescription.push(
        '<html><body><table style="border-collapse: collapse">'
      );
      rowDescription.push("<tr>");
      rowDescription.push(
        '<td style="font-weight: bold; color: #FFFFFF;" bgcolor="000000">ITEM</td><td style="font-weight: bold; color: #FFFFFF" bgcolor="#000000">DESCRIÇÃO</td><td style="font-weight: bold; color: #FFFFFF" bgcolor="#000000">QTD</td><td style="font-weight: bold; color: #FFFFFF" bgcolor="#000000">UN</td>'
      );
      rowDescription.push("</tr>");

      for (const itemsQuoted of supplier.itemsQuoted) {
        const { itemInfo } =
          this.$store.getters["Quote/ITEM_BY_ID"](itemsQuoted);
        const col = [];
        col.push(
          `<td style="border-spacing: 0px; border-collapse: collapse; border-size: .1pt; border-color: #000000; border-style: solid">${itemInfo.number}</td>`
        );
        col.push(
          `<td style="border-collapse: collapse; border-size: .1pt; border-color: #000000; border-style: solid">${itemInfo.description}</td>`
        );
        col.push(
          `<td style="border-collapse: collapse; border-size: .1pt; border-color: #000000; border-style: solid; text-align: center">${itemInfo.quantity}</td>`
        );
        col.push(
          `<td style="border-collapse: collapse; border-size: .1pt; border-color: #000000; border-style: solid">${itemInfo.unity}</td>`
        );
        rowDescription.push("<tr>");
        rowDescription.push(col.join(""));
        rowDescription.push("</tr>");
      }
      rowDescription.push("</table></body></html>");
      const sheetToExport = rowDescription.join("");

      try {
        document.addEventListener("copy", function (e) {
          e.clipboardData.clearData("text/plain");
          e.clipboardData.clearData("text/html");
          e.clipboardData.setData("text/plain", sheetToExport);
          e.preventDefault();
        });
        document.execCommand("copy");
        this.$toasted.success("Resultado copiado");
      } catch (error) {
        return Error(error);
      }
    },
    openMail({ supplierId }) {
      try {
        const supplier =
          this.$store.getters["Quote/SUPPLIER_BY_ID"](supplierId);
        const { identification, client, modality } =
          this.$store.getters["Events/GET_EVENT_DETAILS"];

        if (!(supplier && supplier.itemsQuoted)) {
          return;
        }

        const informedMail =
          supplier.email || "email_nao_informado@sinkr.com.br";
        const subject = `COTAÇÃO ${supplier.name} - LINEA RJ - ${modality} ${identification} ${client.shortName}`;
        const items = [];

        for (const itemsQuoted of supplier.itemsQuoted) {
          const { itemInfo } =
            this.$store.getters["Quote/ITEM_BY_ID"](itemsQuoted);
          items.push(`<tr><td style="border-spacing: 0px; border-collapse: collapse; border-size: .1pt; border-color: #000000; border-style: solid">${itemInfo.number}</td>
            <td style="border-collapse: collapse; border-size: .1pt; border-color: #000000; border-style: solid">${itemInfo.description}</td>
            <td style="border-collapse: collapse; border-size: .1pt; border-color: #000000; border-style: solid; text-align: center">${itemInfo.quantity}</td>
            <td style="border-collapse: collapse; border-size: .1pt; border-color: #000000; border-style: solid">${itemInfo.unity}</td></tr>`);
        }

        const body = this.mountMessageHtmlBody({
          newLine: "<br />",
          items: items.join(""),
        });
        document.addEventListener("copy", function (e) {
          e.clipboardData.clearData("text/plain");
          e.clipboardData.clearData("text/html");
          e.clipboardData.setData("text/html", body);
          e.preventDefault();
        });
        document.execCommand("copy");

        const mailEl = document.createElement("a");
        mailEl.href = `mailto:${informedMail}?Content-type=text/html&subject=${subject}&body=`;
        mailEl.click();
      } catch (error) {
        return Error(error);
      }
    },
    mountMessageHtmlBody({ newLine, items }) {
      const { identification, client, modality, date } =
        this.$store.getters["Events/GET_EVENT_DETAILS"];

      const eventDate = moment(date.event).format("DD/MM/YYYY");
      const eventHour = moment(date.event).format("HH:mm");

      const description = [];
      description.push('<span style="line-height: 26px;">Boa Tarde!</span>');
      description.push(
        `<span style="line-height: 26px;">Solicitamos a seguinte cotação abaixo para participarmos de um pregão na ${client.shortName}.</span>`
      );
      description.push(
        '<span style="line-height: 26px;">Qualquer dúvida, estamos à disposição.</span>'
      );
      description.push("");
      description.push("");
      description.push(
        '<span style="font-weight: bold; line-height: 26px;">LINEA RJ COMÉRCIO LTDA</span>'
      );
      description.push(
        '<span style="font-weight: bold; line-height: 26px;">CNPJ:</span><span> 17.624.789/0001-54</span>'
      );
      description.push("");
      description.push("");
      description.push(
        '<span style="font-weight: bold; line-height: 26px;">DADOS DO PREGÃO:</span>'
      );
      description.push(
        `<span style="font-weight: bold; line-height: 26px;">Órgão:</span> ${client.shortName}`
      );
      description.push(
        `<span style="font-weight: bold; line-height: 26px;">Modalidade:</span> ${MODALITY[modality]}`
      );
      description.push(
        `<span style="font-weight: bold; line-height: 26px;">Nº do Edital:</span> ${identification}`
      );
      description.push(
        `<span style="font-weight: bold; line-height: 26px;">Data de Abertura:</span> ${eventDate}`
      );
      description.push(
        `<span style="font-weight: bold; line-height: 26px;">Horário:</span> ${eventHour}h`
      );
      description.push(
        `<span style="font-weight: bold; color: #FF0000; line-height: 38px;">Sistema de Registro de Preços: 12 meses</span>`
      );
      description.push("");
      description.push(`<table style="border-collapse: collapse">
          <tr>
          <td style="font-weight: bold; color: #FFFFFF;" bgcolor="000000">ITEM</td><td style="font-weight: bold; color: #FFFFFF" bgcolor="#000000">DESCRIÇÃO</td><td style="font-weight: bold; color: #FFFFFF" bgcolor="#000000">QTD</td><td style="font-weight: bold; color: #FFFFFF" bgcolor="#000000">UN</td>
          </tr>
          ${items}
        </table>
      `);
      description.push("");
      description.push("");
      description.push(
        '<span style="font-weight: bold">*Por favor, confirmar recebimento deste e-mail.</span>'
      );
      description.push(
        '<span style="font-weight: bold">*Sinalizar qualquer diferença entre descritivo e produto cotado.</span>'
      );
      description.push(
        '<span style="font-weight: bold">*Destacar descontos e impostos.</span>'
      );
      description.push(
        '<span style="font-weight: bold">*Sinalizar frete CIF ou FOB.</span>'
      );
      description.push("");
      description.push("");
      description.push(
        '<img src="https://sinkr.com.br/static/imgs/linea-signature.png">'
      );

      const body = description.join(newLine);
      return body;
    },
    mountMessageBody({ newLine, items }) {
      const { identification, client, modality, date } =
        this.$store.getters["Events/GET_EVENT_DETAILS"];

      const eventDate = moment(date.event).format("DD/MM/YYYY");
      const eventHour = moment(date.event).format("HH:mm");

      const description = [];
      description.push("Boa Tarde!");
      description.push("");
      description.push(
        `Solicitamos a seguinte cotação abaixo para participarmos de um pregão na ${client}.`
      );
      description.push("");
      description.push("Qualquer dúvida, estamos à disposição.");
      description.push("");
      description.push("");
      description.push("LINEA RJ COMÉRCIO LTDA");
      description.push("");
      description.push("CNPJ: 17.624.789/0001-54");
      description.push("");
      description.push("");
      description.push("DADOS DO PREGÃO:");
      description.push("");
      description.push(`Órgão: ${client.shortName}`);
      description.push("");
      description.push(`Modalidade: ${MODALITY[modality]}`);
      description.push(`Nº do Edital: ${identification}`);
      description.push("");
      description.push(`Data de Abertura: ${eventDate}`);
      description.push("");
      description.push(`Horario: ${eventHour}h`);
      description.push(`Sistema de Registro de Preços: 12 meses`);
      description.push("");

      description.push(...items);

      description.push("");
      description.push("");
      description.push("*Por favor, confirmar recebimento deste e-mail.");
      description.push(
        "*Sinalizar qualquer diferença entre descritivo e produto cotado."
      );
      description.push("*Destacar descontos e impostos.");
      description.push("*Sinalizar frete CIF ou FOB.");

      const body = description.join(newLine);
      return body;
    },
    async sendQuotation({ supplierId, requestDate }) {
      this.responseMode = false;

      const supplierSelection =
        this.$store.getters["Quote/SUPPLIER_BY_ID"](supplierId);
      const computedItems = this.items.filter((i) =>
        supplierSelection.itemsQuoted.includes(i._id)
      );

      this.modalRequestForm = {
        supplierId,
        computedItems,
        requestDate,
      };

      this.$modal.show("modalRequestConfirm");
    },
    responseQuotation({ supplierId }) {
      this.computedItems = null;
      this.filteredComputedItems = null;
      this.$nextTick(() => {
        this.activeFilter.showQuoted = supplierId;
        const supplierSelection =
          this.$store.getters["Quote/SUPPLIER_BY_ID"](supplierId);
        const computedItems = this.items.filter((i) =>
          supplierSelection.itemsQuoted.includes(i._id)
        );
        this.computedItems = computedItems;
        this.filteredComputedItems = computedItems;
        this.responseMode = true;
      });
    },
    closeModalRequestConfirm() {
      this.$modal.hide("modalRequestConfirm");
      this.listAllItems();
    },
    refreshResponseList() {
      this.responseQuotation({
        supplierId: this.activeFilter.showQuoted.toString(),
      });
    },
    filterResponseResult() {
      let filteredResult = JSON.parse(JSON.stringify(this.computedItems));

      if (this.responseFilters.costUnit > 0) {
        filteredResult = filteredResult.filter((suppliers) => {
          const supplierCost = suppliers.suppliersQuote.quotations.filter(
            (supplier) => {
              return (
                supplier.supplier.toString() ===
                this.activeFilter.showQuoted.toString()
              );
            }
          );

          if (this.responseFilters.costUnitSignal === "lte") {
            return (
              supplierCost &&
              supplierCost[0].price <= this.responseFilters.costUnit
            );
          } else {
            return (
              supplierCost &&
              supplierCost[0].price >= this.responseFilters.costUnit
            );
          }
        });
      }

      if (this.responseFilters.costTotal > 0) {
        filteredResult = filteredResult.filter((suppliers) => {
          const supplierCost = suppliers.suppliersQuote.quotations.filter(
            (supplier) => {
              return (
                supplier.supplier.toString() ===
                this.activeFilter.showQuoted.toString()
              );
            }
          );

          if (this.responseFilters.costTotalSignal === "lte") {
            return (
              supplierCost &&
              supplierCost[0].price * suppliers.itemInfo.quantity <=
                this.responseFilters.costTotal
            );
          } else {
            return (
              supplierCost &&
              supplierCost[0].price * suppliers.itemInfo.quantity >=
                this.responseFilters.costTotal
            );
          }
        });
      }

      if (this.responseFilters.quoted !== "all") {
        filteredResult = filteredResult.filter((suppliers) => {
          const supplierCost = suppliers.suppliersQuote.quotations.filter(
            (supplier) => {
              return (
                supplier.supplier.toString() ===
                this.activeFilter.showQuoted.toString()
              );
            }
          );
          if (this.responseFilters.quoted === "quoted") {
            return supplierCost && !supplierCost[0].notQuote;
          } else {
            return supplierCost && supplierCost[0].notQuote;
          }
        });
      }

      if (this.responseFilters.marginProfit > 0) {
        filteredResult = filteredResult.filter((suppliers) => {
          const supplierCost = suppliers.suppliersQuote.quotations.filter(
            (supplier) => {
              return (
                supplier.supplier.toString() ===
                this.activeFilter.showQuoted.toString()
              );
            }
          );

          if (
            supplierCost &&
            supplierCost[0].price &&
            supplierCost[0].maxPrice
          ) {
            const priceWithMargin =
              supplierCost[0].price *
              (this.responseFilters.marginProfit / 100 + 1);
            if (this.responseFilters.marginProfitSignal === "lte") {
              return priceWithMargin >= supplierCost[0].maxPrice;
            } else {
              return priceWithMargin <= supplierCost[0].maxPrice;
            }
          } else {
            return false;
          }
        });
      }

      if (this.responseFilters.estimateUnit > 0) {
        filteredResult = filteredResult.filter((item) => {
          if (!(item && item.itemInfo && item.itemInfo.estimatedPrice)) {
            return true;
          }

          if (this.responseFilters.estimateUnitSignal === "lte") {
            return (
              item.itemInfo.estimatedPrice <= this.responseFilters.estimateUnit
            );
          } else {
            return (
              item.itemInfo.estimatedPrice >= this.responseFilters.estimateUnit
            );
          }
        });
      }

      if (this.responseFilters.estimateTotal > 0) {
        filteredResult = filteredResult.filter((item) => {
          if (!(item && item.itemInfo && item.itemInfo.estimatedPrice)) {
            return true;
          }

          const total = item.itemInfo.estimatedPrice * item.itemInfo.quantity;
          if (this.responseFilters.estimateTotalSignal === "lte") {
            return total <= this.responseFilters.estimateTotal;
          } else {
            return total >= this.responseFilters.estimateTotal;
          }
        });
      }

      this.filteredComputedItems = filteredResult;
    },
    filterByUnitCost(pValue) {
      this.responseFilters.costUnit = this.convertToCurrency(pValue);
      this.filterResponseResult();
    },
    filterByTotalCost(pValue) {
      this.responseFilters.costTotal = this.convertToCurrency(pValue);
      this.filterResponseResult();
    },
    filterByMargin(pValue) {
      this.responseFilters.marginProfit = this.convertToCurrency(pValue);
      this.filterResponseResult();
    },
    filterByUnitEstimate(pValue) {
      this.responseFilters.estimateUnit = this.convertToCurrency(pValue);
      this.filterResponseResult();
    },
    filterByTotalEstimate(pValue) {
      this.responseFilters.estimateTotal = this.convertToCurrency(pValue);
      this.filterResponseResult();
    },
    filterItemsResult() {
      let filteredResult = JSON.parse(JSON.stringify(this.computedItems));
      if (this.itemsFilters.costUnit > 0) {
        filteredResult = filteredResult.filter((item) => {
          if (!(item && item.itemQuoted && item.itemQuoted.cost)) {
            return true;
          }

          if (this.itemsFilters.costUnitSignal === "lte") {
            return item.itemQuoted.cost <= this.itemsFilters.costUnit;
          } else {
            return item.itemQuoted.cost >= this.itemsFilters.costUnit;
          }
        });
      }

      if (this.itemsFilters.costTotal > 0) {
        filteredResult = filteredResult.filter((item) => {
          if (!(item && item.itemQuoted && item.itemQuoted.cost)) {
            return true;
          }

          if (this.itemsFilters.costTotalSignal === "lte") {
            return (
              item.itemQuoted.cost * item.itemInfo.quantity <=
              this.itemsFilters.costTotal
            );
          } else {
            return (
              item.itemQuoted.cost * item.itemInfo.quantity >=
              this.itemsFilters.costTotal
            );
          }
        });
      }

      if (this.itemsFilters.marginProfit > 0) {
        filteredResult = filteredResult.filter((item) => {
          if (
            !(
              item &&
              item.itemQuoted &&
              item.itemQuoted.cost &&
              item.itemInfo.estimatedPrice
            )
          ) {
            return true;
          }
          const priceWithMargin =
            item.itemQuoted.cost * (this.itemsFilters.marginProfit / 100 + 1);
          if (this.itemsFilters.marginProfitSignal === "lte") {
            return priceWithMargin >= item.itemInfo.estimatedPrice;
          } else {
            return priceWithMargin <= item.itemInfo.estimatedPrice;
          }
        });
      }

      if (this.itemsFilters.estimateUnit > 0) {
        filteredResult = filteredResult.filter((item) => {
          if (!item.itemInfo.estimatedPrice) {
            return true;
          }
          if (this.itemsFilters.estimateUnitSignal === "lte") {
            return (
              item.itemInfo.estimatedPrice <= this.itemsFilters.estimateUnit
            );
          } else {
            return (
              item.itemInfo.estimatedPrice >= this.itemsFilters.estimateUnit
            );
          }
        });
      }

      if (this.itemsFilters.estimateTotal > 0) {
        filteredResult = filteredResult.filter((item) => {
          if (!item.itemInfo.estimatedPrice) {
            return true;
          }

          const total = item.itemInfo.estimatedPrice * item.itemInfo.quantity;

          if (this.itemsFilters.estimateTotalSignal === "lte") {
            return total <= this.itemsFilters.estimateTotal;
          } else {
            return total >= this.itemsFilters.estimateTotal;
          }
        });
      }

      this.filteredComputedItems = filteredResult;
    },
    filterItemsByUnitCost(pValue) {
      this.itemsFilters.costUnit = this.convertToCurrency(pValue);
      this.filterItemsResult();
    },
    filterItemsByTotalCost(pValue) {
      this.itemsFilters.costTotal = this.convertToCurrency(pValue);
      this.filterItemsResult();
    },
    filterItemsByMargin(pValue) {
      this.itemsFilters.marginProfit = this.convertToCurrency(pValue);
      this.filterItemsResult();
    },
    filterItemsByUnitEstimated(pValue) {
      this.itemsFilters.estimateUnit = this.convertToCurrency(pValue);
      this.filterItemsResult();
    },
    filterItemsByTotalEstimated(pValue) {
      this.itemsFilters.estimateTotal = this.convertToCurrency(pValue);
      this.filterItemsResult();
    },
    convertToCurrency(v) {
      return Number(v.toString().replace(".", "").replace(",", "."));
    },
    toggleResponseSuppliers() {
      this.activeFilter.showNoResponseSuppliers =
        !this.activeFilter.showNoResponseSuppliers;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/item-quote/ItemQuote.vue